module.exports = __webpack_public_path__ + "static/media/sick-leave.32aa0aaa.svg";